import { Block } from "app/shared/components/blocks/block";
import { ACCOUNT } from "app/shared/services/services-model.type";
import { spacing } from "app/shared/styles/spacing";
import { getAccountStatus } from "app/shared/util/common";
import { formatCurrency } from "app/shared/util/format-currency";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { useTheme, DataTable, Paragraph, TouchableRipple } from "react-native-paper";

interface AccountRollItemProps {
  data: { Payments: ACCOUNT[]; Terms: ACCOUNT[]; Loans: ACCOUNT[] };
  onPressItem: Function;
}

const AccountRollItem = (props: AccountRollItemProps) => {
  const { fonts, colors } = useTheme();
  const { t } = useTranslation();
  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: { paddingHorizontal: spacing.medium },
        header: {
          marginHorizontal: spacing.medium,
          paddingHorizontal: spacing.medium,
          paddingVertical: 0,
          marginBottom: spacing.small,
          backgroundColor: colors.backgroundForm,
          borderBottomWidth: 0,
          borderRadius: 5,
        },
        titleMargin: { marginTop: spacing.medium },
        textHeader: { ...fonts.medium, color: colors.accent, paddingVertical: 0 },
        textBold: { ...fonts.medium, color: colors.text, paddingVertical: 0 },
        text: { ...fonts.regular, color: colors.text, paddingVertical: 0 },
        label: { flex: 1 },
        value: { textAlign: "right" },
      }),
    [colors, fonts],
  );

  const { data, onPressItem } = props;

  const RowHeader = ({ title = "", style = {} }) => (
    <DataTable.Header style={[styles.header, style]}>
      <DataTable.Title>
        <Paragraph style={styles.textHeader}>{title}</Paragraph>
      </DataTable.Title>
    </DataTable.Header>
  );

  const RowItem = (item: ACCOUNT, index: number) => {
    return (
      <TouchableRipple key={`${item.ACCOUNTNO}` + index} style={{ marginHorizontal: spacing.medium }} onPress={() => onPressItem(item)}>
        <Block pv={spacing.small} ph={spacing.medium} bg={index % 2 === 0 ? colors.surface : colors.backgroundForm} br={8}>
          <Block row spaced center>
            <Paragraph style={[styles.textBold, styles.label]}>{t("ACC_SO_TAI_KHOAN")}</Paragraph>
            <Paragraph style={[styles.textBold, styles.value]}>{item.ACCOUNTNO}</Paragraph>
          </Block>
          <Block row spaced center>
            <Paragraph style={[styles.text, styles.label]}>{t("ACC_LOAI_TAI_KHOAN")}</Paragraph>
            <Paragraph style={[styles.text, styles.value]}>{item.ACCOUNTTYPENAME}</Paragraph>
          </Block>
          <Block row spaced center>
            <Paragraph style={[styles.text, styles.label]}>{t("ACC_SO_DU_HIEN_TAI")}</Paragraph>
            <Paragraph style={[styles.text, styles.value]}>{formatCurrency(item.CURRENTBALANCE, item.CURRENCYCODE)}</Paragraph>
          </Block>
          <Block row spaced center>
            <Paragraph style={[styles.text, styles.label]}>{t("ACC_TRANG_THAI")}</Paragraph>
            <Paragraph style={[styles.text, styles.value]}>{getAccountStatus(item.STATUS)}</Paragraph>
          </Block>
        </Block>
      </TouchableRipple>
    );
  };

  return (
    <>
      {data.Payments.length > 0 ? (
        <React.Fragment>
          <RowHeader title={t("ACC_TAI_KHOAN_THANH_TOAN").toUpperCase()} />
          <React.Fragment>{data.Payments.map(RowItem)}</React.Fragment>
        </React.Fragment>
      ) : null}
      {data.Terms.length > 0 ? (
        <React.Fragment>
          <RowHeader title={t("ACC_TAI_KHOAN_TIET_KIEM").toUpperCase()} style={styles.titleMargin} />
          <React.Fragment>{data.Terms.map(RowItem)}</React.Fragment>
        </React.Fragment>
      ) : null}
      {data.Loans.length > 0 ? (
        <React.Fragment>
          <RowHeader title={t("ACC_MAN_TAI_KHOAN_VAY").toUpperCase()} style={styles.titleMargin} />
          <React.Fragment>{data.Loans.map(RowItem)}</React.Fragment>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default AccountRollItem;
